module.exports = __webpack_public_path__ + "static/media/worker-img3.ef0ed20c.webp";